export default __webpack_public_path__ + "static/media/bowie61.1b5d36a9.webp";